module.exports = __webpack_public_path__ + "img/600.3bca4f4c.png";